import { SVGProps, Ref, forwardRef } from 'react';

export const RabotaBySolidSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.82 15h10.36A1.82 1.82 0 0 0 15 13.18V2.82A1.82 1.82 0 0 0 13.18 1H2.82A1.82 1.82 0 0 0 1 2.82v10.36A1.82 1.82 0 0 0 2.82 15m9.02-9.057a2.905 2.905 0 0 1-1.31 3.672l1.53 2.235h-2.1L8.67 9.96H6.32v1.89H4.36v-7.7h4.795a2.905 2.905 0 0 1 2.684 1.793M6.32 8h2.835c.52 0 .945-.425.945-.945a.95.95 0 0 0-.945-.945H6.32z"
            fill="currentColor"
        />
    </svg>
));
RabotaBySolidSize16Glyph.displayName = 'RabotaBySolidSize16Glyph';
